export default function isPlanMenuItemSelected(): boolean {
  return VisitWidget.store.currentMenuItem.entity === "PlanItem";
}
